import { useMemo, useState } from 'react';
import { MappedActivityRating } from '../../types';

export default function usePagination() {
  const [filteredRatings, setFilteredRatings] = useState<MappedActivityRating[]>([]);
  const [ratingsSplited, setRatingsSplited] = useState<Array<MappedActivityRating[]>>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const pagesQuantity = useMemo(() => ratingsSplited.length, [ratingsSplited.length]);

  function handlePageChange(page: number) {
    setCurrentPage(page);
    setFilteredRatings(ratingsSplited[page]);
  }

  return {
    filteredRatings,
    setFilteredRatings,
    setRatingsSplited,
    currentPage,
    setCurrentPage,
    pagesQuantity,
    handlePageChange,
    ratingsSplited,
  };
}
